function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSass(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "76px",
    height: "76px",
    viewBox: "0 0 76 76",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(80%,40%,60%)",
      fillOpacity: 1
    },
    d: "M 11.398438 0 L 64.601562 0 C 70.894531 0 76 5.105469 76 11.398438 L 76 64.601562 C 76 70.894531 70.894531 76 64.601562 76 L 11.398438 76 C 5.105469 76 0 70.894531 0 64.601562 L 0 11.398438 C 0 5.105469 5.105469 0 11.398438 0 Z M 11.398438 0 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 38.296875 13.0625 C 24.046875 17.960938 14.84375 27.90625 15.734375 33.84375 C 16.625 39.78125 25.53125 44.53125 29.539062 47.648438 C 24.34375 50.320312 17.8125 54.328125 17.960938 59.523438 C 18.257812 66.648438 25.976562 64.421875 29.242188 62.34375 C 32.507812 60.265625 35.773438 54.476562 33.695312 48.390625 C 38.296875 47.203125 42.304688 48.6875 43.492188 49.578125 C 48.09375 52.84375 45.71875 56.554688 44.085938 57.148438 C 42.453125 57.742188 43.492188 58.039062 44.53125 57.742188 C 45.570312 57.445312 47.796875 55.960938 47.796875 53.4375 C 47.796875 47.054688 40.96875 44.085938 32.507812 46.3125 C 27.609375 41.117188 20.929688 38.742188 21.226562 33.101562 C 21.375 31.023438 22.117188 25.679688 35.328125 19 C 48.539062 12.320312 57.890625 14.992188 56.703125 21.078125 C 54.921875 30.28125 38.890625 36.515625 33.25 31.171875 C 32.953125 30.578125 31.914062 30.132812 32.507812 31.765625 C 35.476562 39.1875 59.523438 35.773438 60.5625 20.039062 C 60.859375 11.726562 48.835938 9.5 38.296875 13.0625 Z M 25.53125 60.5625 C 21.820312 61.75 21.96875 59.375 22.117188 58.484375 C 22.5625 55.960938 24.640625 52.84375 30.875 49.726562 C 32.65625 55.367188 28.648438 59.671875 25.53125 60.5625 Z M 25.53125 60.5625 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSass);
export default __webpack_public_path__ + "static/media/sass.35f410de750e363b9e717f635ce07e4e.svg";
export { ForwardRef as ReactComponent };